/* eslint-disable react/prop-types */
import classes from "./card-view-announcement.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import TextTruncate from "@/components-library/widgets/text-truncate/text-truncate";
import { PLACEHOLDER } from "@/common/announcement-helper";
function CardViewCorrelatedAnnouncement({
  title,
  date,
  image,
  admin,
  onShowInfo,
  isInOffer,
  onAnnouncementAdd,
  isSelectable,
}) {
  var dateLabel = "Scadenza cumulabilità:";
  return (
    <Flex
      align="center"
      direction="column"
      justify="center"
      className={classes.container}
    >
      <img
        src={image ? image : PLACEHOLDER}
        alt="Logo"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = PLACEHOLDER;
        }}
        className={classes.image}
      />
      <Flex
        align="flex-start"
        direction="column"
        justify="space-between"
        className={classes.content}
      >
        <TextTruncate
          line={3}
          element={"h6"}
          truncateText="…"
          text={title}
          containerClassName={classes.title}
          maxCalculateTimes={100}
        />
        <div>
          <Label
            weight="bold"
            align="start"
            size="sm"
            color="secondary"
            className={classes.date}
          >
            {`${dateLabel} ${date}`}
          </Label>
          {!isInOffer && isSelectable && (
            <Button
              onClick={onAnnouncementAdd}
              size="sm"
              color="primary"
              isEnabled={!admin}
              className={classes.button}
            >
              {"AGGIUNGI ALL'OFFERTA"}
            </Button>
          )}
        </div>
        {!isSelectable && !admin && !isInOffer && (
          <Label
            align="start"
            size="md"
            color="secondary"
            weight="bold"
            className={classes.errorMessage}
          >
            Bando non selezionabile
          </Label>
        )}
        {isInOffer && (
          <Flex
            align="center"
            direction="row"
            justify="space-between"
            style={{ width: "100%" }}
          >
            <Flex align="center" direction="row" justify="flex-start">
              <img src={"/images/icons/checkmark.svg"} alt="Check" />
              <Label weight="bold" color="primary" align="start" size="sm">
                BANDO AGGIUNTO
              </Label>
            </Flex>
            <img
              src={"/images/icons/icon-close.svg"}
              alt="Check"
              onClick={onAnnouncementAdd}
            />
          </Flex>
        )}
      </Flex>

      <img
        src={"/images/icons/icon-preview.svg"}
        alt="Logo"
        className={classes.showInfo}
        onClick={onShowInfo}
      />
    </Flex>
  );
}

export default CardViewCorrelatedAnnouncement;
